import { render, staticRenderFns } from "./buscarProductosModal.vue?vue&type=template&id=37277e15&"
import script from "./buscarProductosModal.vue?vue&type=script&lang=js&"
export * from "./buscarProductosModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QSelect,QBtn,QTooltip,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QSelect,QBtn,QTooltip,QTable})
